import { useSelector } from "react-redux";
import { IStudentLessons } from "redux/reducers/studentLessonsSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

export const useStudentLessonsSelectors = () => {
  const studentLessons = useSelector<
    RootSliceType,
    IStudentLessons["studentLessons"]
  >((state) => state.studentLessons.studentLessons);

  const myLessons = useSelector<RootSliceType, IStudentLessons["myLessons"]>(
    (state) => state.studentLessons.myLessons
  );
  return {
    studentLessons,
    myLessons,
  };
};

export default useStudentLessonsSelectors;
